import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { blue } from "@material-ui/core/colors";
import { grey } from "@material-ui/core/colors";
import { hexToRgb } from "./Utils";

const useStyles = makeStyles((theme) => ({
  header: {
    whiteSpace: "pre-wrap",
  },
  tableContainer: {
    margin: "30px 30px 0px 30px",
    width: "fit-content",
    alignSelf: "center",
    overflowX: "visible",
  },
  table: {
    "& *": {
      fontWeight: "400",
      fontSize: "1.1rem",
    },
  },

  numberContainer: {
    display: "flex",
    justifyContent: "center",
  },
  trafficLight: {
    width: "1rem",
    height: "1rem",
    borderRadius: "0.5rem",
    display: "inline-block",
    marginRight: "8px",
  },
}));

export default function DataTable({ title, cities, global }) {
  const classes = useStyles();

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <Table className={classes.table} component="div">
        <TableHead component="div">
          <TableRow component="div">
            <TableCell
              align="center"
              component="div"
              style={{
                display: "flex",
                color: "white",
                backgroundColor: title !== "Muertes" ? blue[500] : grey[700],
                borderRadius: "4px",
              }}
            >
              <span
                style={{
                  flex: 1,
                }}
              >
                Municipio&nbsp;&nbsp;
              </span>
              <span>{title}</span>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody component="div">
          {cities.map((city, idx) => {
            const { r, g, b } = hexToRgb(city.color);
            const percentage = Math.round(
              (title !== "Muertes"
                ? city.newCases / global
                : city.newDeaths / global) * 100
            );

            return (
              <TableRow key={idx} component="div">
                <div
                  style={{
                    display: "flex",
                    background: `linear-gradient(to right, rgba(${r}, ${g}, ${b}, 0.8) 100%, white 0%)`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: `${percentage}% 5px`,
                    backgroundPositionY: "bottom",
                  }}
                >
                  <TableCell
                    align="center"
                    style={{
                      flex: 1,
                    }}
                    component="div"
                  >
                    <div
                      className={classes.trafficLight}
                      style={{
                        backgroundColor: `rgba(${r}, ${g}, ${b}, 0.8)`,
                      }}
                    ></div>
                    {city.name}
                  </TableCell>
                  <TableCell align="center" component="div">
                    {title !== "Muertes" ? city.newCases : city.newDeaths}
                  </TableCell>
                </div>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
